<template>
  <div :class="$style.wrapper">
    <div :class="$style.toolBar">
      <IconButton
        data-test-id="ManageAccountToolbar__AddAccount"
        icon="add"
        text="Add Account"
        type="primary"
        @click="handleAddNewAccountClick"
      />

      <InputSearch
        v-if="false"
        ref="search"
        v-model="searchTerm"
        :class="$style.search"
        data-test-id="ManageAccountToolbar__search"
        placeholder="Search"
      />
    </div>

    <div :class="$style.tools">
      <IconButton
        v-if="false"
        data-test-id="ManageAccountToolbar__Export"
        hasNoBackground
        icon="fileDownload"
        text="Export"
        type="secondary"
        @click="handleExportClick"
      />

      <Button
        v-if="false"
        data-test-id="ManageAccountToolbar__Filter"
        hasOutline
        text="Filter"
        type="secondary"
        @click="handleFilterClick"
      />
    </div>
  </div>
</template>

<script>
import { Button, IconButton, InputSearch } from '@jumpcloud/ui-components';

export default {
  name: 'ManageAccountItemListToolbar',

  components: {
    InputSearch,
    IconButton,
    Button,
  },

  props: {
    totalEvents: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      searchTerm: '',
    };
  },

  methods: {
    handleAddNewAccountClick() {
      this.$emit('addAccountButtonClick');
    },
    handleExportClick() {
      // Placeholder for future work
    },
    handleFilterClick() {
      // Placeholder for future work
    },
  },
};
</script>

<style module scoped>
.search {
  margin-left: 15px !important;
}

.toolBar {
  align-items: center;
  display: flex;
  font-size: var(--jc-size-0p875);
  font-weight: 600;
}

.tools {
  display: flex;
  gap: 25px;
  justify-content: flex-end;
}

.wrapper {
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: var(--jc-spacer) var(--jc-spacer) var(--jc-spacer) 0;
}
</style>
